import { Grid, GridItem, Heading, Text } from "@chakra-ui/react";
import { VaultDetails } from "../../types/vault";

export default function FeeList({ vaultDetails }: { vaultDetails: VaultDetails | undefined }) {
  // TODO: render bips
  return (
    <Grid py="2.5em" templateColumns="repeat(7, 1fr)" rowGap="1em">
      <GridItem colSpan={7}>
        <Heading size="md">Fees</Heading>
      </GridItem>

      <GridItem colSpan={2}>
        <Text>Entry fee:</Text>
      </GridItem>
      <GridItem colSpan={5}>
        {vaultDetails?.entryFee?.toString()} %<Text fontSize="xs">Deducted on deposit.</Text>
      </GridItem>

      <GridItem colSpan={2}>
        <Text>Exit fee:</Text>
      </GridItem>
      <GridItem colSpan={5}>
        {vaultDetails?.exitFee?.toString()} %<Text fontSize="xs">Deducted on redeem.</Text>
      </GridItem>

      <GridItem colSpan={2}>
        <Text>Execution fee:</Text>
      </GridItem>
      <GridItem colSpan={5}>
        {vaultDetails?.executionFee?.toString()} %<Text fontSize="xs">Deducted on DCA.</Text>
      </GridItem>
    </Grid>
  );
}
